import React, { useState, useEffect } from "react";
import "../../Table/Table.css";
import axios from "axios";
import { config } from "./../../../confi";
import { SearchOutlined } from "@ant-design/icons";
import Spinner from "../../Loader/Spinner";
import { filter } from "@chakra-ui/react";

function New_table() {
  let [Data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [Search, setSearch] = useState("");
  const [filterby,SetFilterby] = useState("ALL")
  const [searchby,SetSearchby] = useState('')
const [Limit,Setlimit]  = useState(10)

  //------------------ UI state -----------------//
  const [loading, setLoading] = useState(false);
  const [msg, setmsg] = useState(false);

//----------------input change handler -----------//


const input_change_handler = (e) =>{

if(e.target.name ==='filter_select'){

  SetFilterby(e.target.value)
}

if(e.target.name ==="search-12"){

  SetSearchby(e.target.value)
}

if(e.target.name === "limit-select"){


  Setlimit(e.target.value)
}



}

//------------------search by member recient no --------///


  const Search_Handler = () =>{

    FetchHandler()

  }



  //--------  data fetch function  ---------////

  async function FetchHandler() {
    let reqbody = JSON.stringify({
      fn: "common_fun",
      an: "mst_re_me",
      payload: { page: currentPage ,filter_input:filterby,searchby:searchby,limit:Limit },
    });

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.apiBaseURL}/root`,
        { data: reqbody },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      // console.log(response);
      // console.log(response.data.data);
      if (response.status === 200 && response.data.status === "0") {
        // setData(response.data.data);
        setData(response.data.data)



      } else {
      }
    } catch (error) {}
    setLoading(false);
  }

  //-----------------//////////////
  useEffect(() => {
    FetchHandler();
  }, [currentPage,filterby,Limit]);

  return (
    <div className="my-table">
      <div>
        {loading ? (
          <span style={{ textAlign: "center" }}>
            {" "}
            <Spinner />
          </span>
        ) : (
          <div>
            <div className="div-for-search">
              <p>Outstanding Report</p>
              <div className="serchdiv">
                <input placeholder="Rec.no/Name/Mobile" type ="text" name ="search-12" value={searchby} onChange={input_change_handler}></input>
                <button className="searchbtn2" onClick={Search_Handler} ><SearchOutlined /></button>
                <select placeholder="select Filter" name ="filter_select" value={filterby} onChange={input_change_handler}>
                  <option  value="1">All</option>
                  <option  value="2">due Balance</option>
                  <option  value="3">Non due Balance</option>
                </select>
              
              </div>
            </div>
            <table className="my-table-main">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Member Rec. No.</th>
                  <th>Mobile No.</th>
                  <th>Reguler</th>
                  <th>Speacial</th>
                  <th>Sponsor</th>
                  <th>Olian</th>
                  {/* <th>Total Amount</th> */}
                  <th>Total commit Amount</th>
                  <th>Total Cash</th>
                  <th>Total Cheque</th>
                  <th>Total Received Amount</th>
                  <th>Total Dates Display</th>
                  <th>Balance</th>
                </tr>
              </thead>
              {Data.length > 0 ? (
                <tbody>
                  {Data.map((e, i) => {
                    return (
                      <>
                        <tr key={i}>
                          <td>{e.name_person}</td>
                          <td>{e.membership_rec_no}</td>
                          <td>{e.mobile_no}</td>
                          <td>{e.regular}</td>
                          <td>
                          {e.special}
                          </td>
                          <td>{e.sponsor}</td>
                          <td>{e.Olian}</td>
                          {/* <td>{e.total_amount}</td> */}
                          <td>{e.commited_amount}</td>
                          <td>{e.total_cash}</td>
                          <td>{e.total_cheque}</td>
                          <td>{e.total_recieve_amount}</td>
                          <td>{e.total_date_display}</td>
                          <td>{e.balance}</td>
                          
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              ) : (
                <span style={{ textAlign: "center", display: "inline-block" }}>
                  {" "}
                  No Record
                </span>
              )}
            </table>

            <div style={{ marginTop: "5px", textAlign: "center" }}>
              <button
                className={`${
                  currentPage === 1
                    ? "pagination-btn-disabled"
                    : "pagination-btn "
                }`}
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="Page-text">Page {currentPage}</span>
              <button
                className={`${
                  Data.length < 10
                    ? "pagination-btn-disabled"
                    : "pagination-btn "
                }`}
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage < 1 || Data.length < 10}
              >
                Next
              </button>


              <select className="limit-input" placeholder="Select Limit" name ="limit-select" value={Limit} onChange={input_change_handler}>
                  <option  value="10">10</option>
                  <option  value="20">20</option>
                  <option  value="50">50</option>
                  <option  value="100">100</option>
                </select>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default New_table;
